module.exports = __webpack_public_path__ + "static/media/ico_cancelada.37c1abe9.svg";